import React from "react";
import { Checkbox, FormGroup } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import { StyledFormControlLabel } from "../../../../components/FormikFields/FormikCheckbox";
import { Schedule } from "./types";
import { WEEKDAY_NIGHT_STARTS, WEEKEND_NIGHT_STARTS } from "./constants";
import {
  applyNightSchedule,
  clearNightSchedule,
  hasNightSchedule,
} from "./utils";

const ChecksGroup = styled(FormGroup)`
  gap: 0.75rem;
`;

interface NightScheduleChecksProps {
  schedule: Schedule;
  onChange: (schedule: Schedule) => void;
  className?: string;
  style?: React.CSSProperties;
}

// Checks de noches sin estado propio: se derivan del schedule y al
// marcarlos/desmarcarlos se añaden o quitan las franjas nocturnas (21:00-09:00).
const NightScheduleChecks = ({
  schedule,
  onChange,
  className,
  style,
}: NightScheduleChecksProps) => {
  const weekdayNights = hasNightSchedule(schedule, WEEKDAY_NIGHT_STARTS);
  const weekendNights = hasNightSchedule(schedule, WEEKEND_NIGHT_STARTS);

  const handleNightsChange = (startDayKeys: string[], checked: boolean) => {
    onChange(
      checked
        ? applyNightSchedule(schedule, startDayKeys, true, true)
        : clearNightSchedule(schedule, startDayKeys)
    );
  };

  return (
    <ChecksGroup className={className} style={style}>
      <StyledFormControlLabel
        variant="standard"
        checked={weekdayNights}
        control={
          <Checkbox
            color="primary"
            checked={weekdayNights}
            onChange={(e) =>
              handleNightsChange(WEEKDAY_NIGHT_STARTS, e.target.checked)
            }
          />
        }
        label={
          <FormattedMessage
            id="CalendarPage.WeekdayNights"
            defaultMessage="Noches entre semana"
          />
        }
      />
      <StyledFormControlLabel
        variant="standard"
        checked={weekendNights}
        control={
          <Checkbox
            color="primary"
            checked={weekendNights}
            onChange={(e) =>
              handleNightsChange(WEEKEND_NIGHT_STARTS, e.target.checked)
            }
          />
        }
        label={
          <FormattedMessage
            id="CalendarPage.WeekendNights"
            defaultMessage="Noches fin de semana"
          />
        }
      />
    </ChecksGroup>
  );
};

export default NightScheduleChecks;
